<template>
    <v-expansion-panels accordion flat>
        <v-expansion-panel>
            <v-expansion-panel-header v-slot="{open}" class="pa-0">
                <div class="v-label theme--light mb-2">
                    <label :class="{'primary--text' : open}">{{label}} ({{items.length}})</label>
                </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <draggable v-model="items" handle=".drag-handle" tag="div" @end="emitValue">
                    <div v-for="(item, index) in items" :key="index" class="d-flex align-center">
                        <v-icon class="drag-handle" small>mdi-drag</v-icon>
                        <v-row dense>
                            <v-col v-for="field in config" :key="field.id" cols="5">
                                <v-text-field
                                    :label="$translate(field.title)"
                                    v-model="item[field.id]"
                                    @input="emitValue"
                                />
                            </v-col>
                            <v-col cols="2">
                                <v-btn @click="remove(index)" color="error" fab small>
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </draggable>

                <div class="d-flex align-center">
                    <v-icon class="drag-handle" small>mdi-drag</v-icon>
                    <v-row dense>
                        <v-col v-for="field in config" :key="field.id" cols="5">
                            <v-text-field :label="$translate(field.title)" v-model="newItem[field.id]" />
                        </v-col>
                        <v-col cols="2">
                            <v-btn :disabled="!isValidNewItem" @click="add" color="success" fab small>
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
import Draggable from "vuedraggable";

export default {
    name: "zoezi-multi-text-setting",
    components: {
        Draggable,
    },
    props: {
        label: String,
        value: Array,
        config: Array, // List of { id: "prefix", title: "Prefix", required: true }
    },
    data: () => ({
        items: [],
        newItem: {}
    }),
    computed: {
        isValidNewItem() {
            return this.config.every(field => !field.required || this.newItem[field.id]);
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(val) {
                this.items = val ? [...val] : [];
            },
        },
    },
    methods: {
        emitValue() {
            this.$emit("input", this.items);
        },
        add() {
            this.items.push({ ...this.newItem });
            this.newItem = {};
            this.emitValue();
        },
        remove(index) {
            this.items.splice(index, 1);
            this.emitValue();
        },
    },
};
</script>

<style scoped>
.drag-handle {
    cursor: grab;
    margin-right: 10px;
}
</style>
